import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { PointBasedGrid } from "src/types";

export function usePointBasedGridSchema(data: PointBasedGrid) {
  const { t } = useTranslation();

  return Yup.object().shape({
    numberOfCircles: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.numberOfCircles"),
        })
      )
      .min(
        data.numberOfCircles.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.numberOfCircles"),
          value: data.numberOfCircles.minMaxDefault.min,
        })
      )
      .max(
        data.numberOfCircles.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.numberOfCircles"),
          value: data.numberOfCircles.minMaxDefault.max,
        })
      ),
    pointsPerCircle: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.pointsPerCircle"),
        })
      )
      .min(
        data.pointsPerCircle.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.pointsPerCircle"),
          value: data.pointsPerCircle.minMaxDefault.min,
        })
      )
      .max(
        data.pointsPerCircle.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.pointsPerCircle"),
          value: data.pointsPerCircle.minMaxDefault.max,
        })
      ),
    minDistance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceOfFirstCircle"),
        })
      )
      .min(
        data.minDistance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceOfFirstCircle"),
          value: data.minDistance.minMaxDefault.min,
        })
      )
      .max(
        data.minDistance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceOfFirstCircle"),
          value: data.minDistance.minMaxDefault.max,
        })
      ),
    maxDistance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceOfLastCircle"),
        })
      )
      .min(
        data.maxDistance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceOfLastCircle"),
          value: data.maxDistance.minMaxDefault.min,
        })
      )
      .max(
        data.maxDistance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceOfLastCircle"),
          value: data.maxDistance.minMaxDefault.max,
        })
      ),
    tolerance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.tolerance"),
        })
      )
      .min(
        data.tolerance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.tolerance"),
          value: data.tolerance.minMaxDefault.min,
        })
      )
      .max(
        data.tolerance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.tolerance"),
          value: data.tolerance.minMaxDefault.max,
        })
      ),
  });
}
